const portfolioItemIsInvalid = item =>
  item.company.id === 'whole_sector' ?
    false : !item.company.current

export const portfolioHasInvalidCompany = portfolio => 
  portfolio.overview.some(portfolioItemIsInvalid)
